/* eslint-disable no-underscore-dangle */
import { throwOnError } from './utils';

type Paginated<T> = {
  rows: T[];
  count: number;
  pagination: {
    has_next: boolean;
    has_prev: boolean;
    max_page: number;
    per_page: number;
    current: number;
  };
};

type PrivateMoneyAccountHookResponse = {
  id: string;
  name: string;
  description: string | null;
  point_amount: number;
  usage_count: number;
  usage_limit: number | null;
  is_disabled: boolean;
  starts_at: string | null;
  ends_at: string | null;
  point_expires_at: string | null;
  point_expires_in_days: number | null;
  sender: {
    id: string;
    name: string;
  } | null;
  sender_account: {
    id: string;
    name: string;
  };
  bear_point_account: {
    id: string;
    name: string;
  } | null;
};

type PrivateMoneyAccountHooksResponse = Paginated<PrivateMoneyAccountHookResponse>;

export const fetchPrivateMoneyAccountHook = (id: string, query = '') =>
  fetch(`/api/private-money-account-hooks/${id}?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<PrivateMoneyAccountHookResponse>);

export const fetchPrivateMoneyAccountHooks = (query = '') =>
  fetch(`/api/private-money-account-hooks?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<PrivateMoneyAccountHooksResponse>);

export const updatePrivateMoneyAccountHook = (id: string, updated: Record<string, unknown> = {}) =>
  fetch(`/api/private-money-account-hooks/${id}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...updated }),
  }).then(throwOnError<PrivateMoneyAccountHookResponse>);

export const createPrivateMoneyAccountHook = (params: Record<string, unknown> = {}) =>
  fetch('/api/private-money-account-hooks', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...params }),
  }).then(throwOnError);
